<template>
  <div class="index" v-loading="loading" element-loading-text="拼命加载中">
    <div class="title">
      <h3>设备列表<span>({{total}}台)</span></h3>
    </div>
    <div class="pdaBoxs">
      <el-form ref="form" :model="form">
        <el-form-item style="width:180px">
          <el-input v-model="form.deviceName" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item style="width:180px">
          <el-input v-model="form.userN" placeholder="请输入用户名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-cascader ref="city" :options="options" :filterable="true" @change="handleChange()">
          </el-cascader>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.type" placeholder="请选择种类">
            <el-option label="请选择种类" value=""></el-option>
            <el-option label="羊" value="羊"></el-option>
            <el-option label="牛" value="牛"></el-option>
            <el-option label="猪" value="猪"></el-option>
            <el-option label="鸡" value="鸡"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.online" placeholder="请选择设备状态">
            <el-option label="请选择设备状态" value=""></el-option>
            <el-option label="在线" value="0"></el-option>
            <el-option label="离线" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button>重置</el-button>
          <el-button type="primary" @click="onSubmit">搜索</el-button>
        </el-form-item>
      </el-form>
      <div class="layuiPdaList">
        <ul class="oul over_h">
          <li v-for="(item,index) in elementList">
           <div v-if="item.takeEffect==1" class="aiAb open"><img src="../../assets/img/openai.svg" /><span>值守中</span></div>
           <div v-else-if="item.takeEffect==2" class="aiAb unnormal"><img src="../../assets/img/u717.png" /><span>异常</span></div>
            <div class="aiAb unopen" v-else><img src="../../assets/img/u717.png"><span>未开启</span></div>
            <div class="imgCover">
              <!--  -->
              <!-- id="myVideo" -->
              <div v-if="item.videoShow" class="img">
                <video id="myVideo" src="" ref="video" autoplay controls>
                </video>
                <!-- <video :ysrc="item.hls"></video> -->

              </div>
              <div class="img" v-else>
                  <img @click="video(item,item.deviceSerialId,item.hls,index)" v-if="item.videoThumb!=null&&item.videoThumb!=''" :src="item.videoThumb" />
                  <img @click="video(item,item.deviceSerialId,item.hls,index)" v-else src="../../assets/img/img1.png"/>
              </div>
            </div>


            <div class="info">
              <div class="name">
                <div class="over_h">
                  <div class=" fl text-"
                    style="max-width: 73%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">{{item.deviceName||'暂无设备'}}</div>
                  <div class="fl liveW">{{item.livestockType}} /</div>
                </div>
              </div>
              <div class="users"><img :src="item.avatar" />{{item.userName||'用户名'}}<span class="userID">ID:{{item.userAccount}}</span></div>
              <div class="address"><img src="../../assets/img/u10.png" />{{item.deviceAddress}}</div>
            </div>
          </li>
        </ul>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total" :page-size="15" :page-count="total" @current-change="currentPage" @prev-click="prev" @next-click="next">
      </el-pagination>
    </div>
  </div>
</template>
<!-- <script src="https://cdn.bootcss.com/hls.js/8.0.0-beta.3/hls.min.js"></script> -->
<script src="https://cdn.jsdelivr.net/npm/hls.js@latest"></script>
<script>
  import Vue from 'vue'
   window.Hls = require('hls.js')
    import DPlayer from 'dplayer';
  import {
    deviceList
  } from '../../api/device'
  import options from '../../api/city-data.js'
  import 'video.js/dist/video-js.css'
   import videojs from 'video.js';
    import 'videojs-contrib-hls'
  export default {
    data() {


      return {
        loading:true,
        options: null,
        open: true,
        exit: false,
        fullscreen: false,
        videoIndex:'0',
        form: {

          deviceName: '',
          userN: '',
          type: '',
          online: '',
          cityName: '',
          countyName: '',
          provinceName: '',

        },
        pageNum: 1,
        total: 0,
        totalPage:1,
        elementList: []
      }
    },
    // created() {
    //  let areaDetail = localStorage.getItem('area')
    //  console.log('huoqu area  area  area ')
    //  console.log(areaDetail)
    //   this.cityName =''
    //     this.countyName = ''
    //     this.provinceName = ''

    // },
    mounted() {
      let areaDetail = JSON.parse(localStorage.getItem('area'))
       this.form.cityName = areaDetail.city
       this.form.countyName = areaDetail.county
      this.form.provinceName = areaDetail.province
      let option = options.options
      option.forEach(item=>{
        if(item.children!=undefined){
          if(item.children.length>1){
            item.children.unshift({
              value:'0',
              label:'全部市区',
              children:[]
            })
            item.children.forEach(items=>{
                if(items.children!=undefined){
                  if(items.children.length>0){
                      items.children.unshift({
                    value:'001',
                    label:'全部县区'
                  })
                    }
                }

            })
          }else{
            item.children.forEach(items=>{
                if(items.children!=undefined){
                  if(items.children.length>0){
                      items.children.unshift({
                    value:'001',
                    label:'全部县区'
                  })
                    }
                }

            })
          }
        }

      })
      this.options = option
      this.getList()

    },
    methods: {




      // 点击显示视频
      video(item,id,hls,index){

        this.videoIndex = index
           item.videoShow = !item.videoShow
           // this.playVideo('')//播放其它视频前执行，清空之前的url
           // this.playVideo(id,'http://hls01open.ys7.com/openlive/70735140acde4c0db233001bece35f67.hd.m3u8')//调用
        // this.playM3u8(hls,id)


      setTimeout(function(){
        videojs('myVideo', {   //播放的事件
                    textTrackDisplay: false,
                    posterImage: true,
                    errorDisplay: false,
                    controlBar: true,
                    hls: {
                      withCredentials: true
                    }
                  }, function () {
                    // this.play()   //取消自动播放
                  })
      },1000)


      },
      // 页码
      currentPage(e){
        this.loading = true
        this.pageNum = e
        this.getList()
      },
      prev(e){
        this.loading = true
        this.pageNum = e
        this.getList()
      },
      next(e){
        this.loading = true
        this.pageNum = e
        this.getList()
      },
      handleChange(item) {
        let cityList = this.$refs['city'].getCheckedNodes()[0].pathLabels
        this.form.cityName = cityList[1]

        this.form.provinceName = cityList[0]
        if(cityList[2]=='全部地区'){
           this.form.countyName = ''
        }else{
           this.form.countyName = cityList[2]
        }
        if(cityList[1]=='全部市区'){
          this.form.cityName = ''
        }else{
           this.form.cityName = cityList[2]
        }

      },
      onSubmit() {
        this.getList()
      },
      getList() {
        let params = {
          city: this.form.cityName,
          country: this.form.countyName,
          deviceName: this.form.deviceName,
          endNumber: '',
          livestockType: this.form.type,
          onLine: this.form.online,
          pageNum: this.pageNum,
          pageSize: 15,
          province: this.form.provinceName,
          sortType: '',
          startNumber: '',
          userAccount: '',
          userName: this.form.userN
        }
        var _this = this
        deviceList(params)
          .then(res => {
            _this.loading = false
            if (res.status == '200') {
              res.data.elements.forEach(item=>{
                  Vue.set(item, 'videoShow', false);
              })
              _this.total = res.data.totalElements
              _this.elementList = res.data.elements

              _this.totalPage = res.data.totalPage
            } else {
              _this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            _this.loading = false
            // _this.$message.error('加载失败，请稍后再试！')
          })
      },
    },
    // 注册组件
    components: {

    },
    created() {

    },
  }
</script>

<style scoped>
  .layuiPdaList{
    height: calc( 100vh - 384px );
    overflow-y: auto;
  }
  @media (max-width: 1500px) {
    .layuiPdaList{
      height: calc( 100vh - 445px );
    }
  }
  .title {
    height: 60px;
    line-height: 60px;
    margin: 0;
  }

  .title h3 {
    margin: 0 !important;
  }

  .title h3 span {
    font-weight: normal;
    font-size: 16px;
    margin-left: 10px;
  }

  /deep/.el-main {
    background: #f7f7f7 !important;
  }

  .pdaBoxs {
    background: #fff;
    padding: 20px 20px 10px 20px;
  }

  .oul li {
    float: left;
    margin: 0px 20px 20px 0;
    font-size: 16px;
    width: 320px;
    height: 320px;
    color: #333;
    transition: all .3s;
    position: relative;
    padding: 0;
    line-height: inherit;
    border-radius: 5px;
  }

  .oul li>.imgCover {
    width: 318px;
    height: 180px;
    cursor: pointer;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
  }
  .imgCover .img{
    width: 318px;
    height: 180px;
    cursor: pointer;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
  }
  .imgCover .img>image{
    width: 318px;
    height: 180px;
  }
  .imgCover .img>video{
    width: 318px;
    height: 180px;
  }
  .info{
  	padding: 0 10px;
  }
  .info > div{
  	margin-top:10px;
  	text-overflow: ellipsis;
  	white-space: nowrap;
  	overflow: hidden;
  }
  .address{
  	color:#999
  }
  .address>img{
  	margin-right: 10px;
  	width: 16px;
    height: 16px;
  }
  .users{
  	font-weight: 700;
  }
  .users>img{
  	margin-right: 10px;
  	width: 20px;
  	height: 20px;
  	border-radius: 50%;
  }
  .userID{
  	margin-left:15px;
  	font-weight: normal!important;
  	color: #999;
  }
  .liveW{
  	padding: 3px 5px;
  	background:rgba(245, 245, 245, 1);
  	color: #333;
  	border-radius: 5px;
  	font-size: 12px;
  	margin-left: 10px;
  }
  .aiAb{
  	position: absolute;
  	top: 0;
  	left: 0;
  }
  .aiAb img{
  	position: absolute;z-index: 99;
  }
  .aiAb span{
  	font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  	font-weight: 700;
  	font-size: 16px;
  	line-height: 40px;
  	position: absolute;
  	z-index: 99;
  }
  .aiAb.open{
  	width: 140px;height: 60px;
  }
  .aiAb.open:after{
  	content: '';position: absolute;
  	left: -5px;top:-5px;
  	width: 140px;height: 60px;
  	background:url(../../assets/img/opaibg.svg) no-repeat center;
  	background-size: cover;
  	opacity: .9;
  }
  .aiAb.open img{
  	width: 44px;height: 38px;
  }
  .aiAb.open span{
  	color: rgba(0, 0, 0, 0.996078431372549);
  	left: 55px;
  }
  .aiAb.unnormal{
  	width: 120px;height: 40px;
  }
  .aiAb.unnormal:after{
  	content: '';position: absolute;
  	width: 120px;
  	height: 40px;
  	background: -webkit-linear-gradient(180deg, rgba(217, 33, 33, 1) 0%, rgba(255, 74, 38, 1) 100%);
  	background: -moz-linear-gradient(270deg, rgba(217, 33, 33, 1) 0%, rgba(255, 74, 38, 1) 100%);
  	background: linear-gradient(270deg, rgba(217, 33, 33, 1) 0%, rgba(255, 74, 38, 1) 100%);
  	border: none;
  	border-radius: 0px;
  	border-top-right-radius: 0px;
  	border-bottom-left-radius: 0px;
  	-moz-box-shadow: 5px 5px 10px rgba(217, 0, 27, 0.498039215686275);
  	-webkit-box-shadow: 5px 5px 10px rgba(217, 0, 27, 0.498039215686275);
  	box-shadow: 5px 5px 10px rgba(217, 0, 27, 0.498039215686275);
  }
  .aiAb.unnormal img{
  	width: 24px;
  	height: 18px;
  	left: 10px;
  	top:0;bottom: 0;margin: auto;
  }
  .aiAb.unnormal span{
  	color: #fff;
  	left: 65px;
  }

  .aiAb.unopen{
  	width: 120px;height: 40px;
  }
  .aiAb.unopen:after{
  	content: '';position: absolute;
  	width: 120px;
  	height: 40px;
  	opacity: .6;
  	background-color: rgba(0, 0, 0, 1);
  	-moz-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.247058823529412);
  	-webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.247058823529412);
  	box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.247058823529412);
  }
  .aiAb.unopen img{
  	width: 24px;
  	height: 18px;
  	left: 10px;
  	opacity: .6;
  	top:0;bottom: 0;margin: auto;
  }
  .aiAb.unopen span{
  	color: #fff;opacity: .6;
  	left: 55px;
  }

</style>



// WEBPACK FOOTER //
// src/views/pdaList/pdaList.vue